export default "__VITE_ASSET__QgjMtsQ4__"